"use client";
import { Back } from "../mainHeader/Back";
import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/AIInsight/DocsBack";

const I18n = I18nUtil.createScoped(Translations);

export const DocsBack = () => {
  return (
    <Back
      title={I18n.t("Back")}
      iconSize={16}
      className="mt-[26px] ml-[26px]"
    />
  );
};
